import { resolveFabledRole } from "../fabledRole";

export default store => {
  // The public product name stays consistent in the lobby, town square and
  // grimoire. The upstream mode switch used to restore the old English title.
  const updatePagetitle = () => (document.title = "sea的桌游屋");

  // initialize data
  if (localStorage.getItem("background")) {
    store.commit("setBackground", localStorage.background);
  }
  if (localStorage.getItem("muted")) {
    store.commit("toggleMuted", true);
  }
  if (localStorage.getItem("static")) {
    store.commit("toggleStatic", true);
  }
  if (localStorage.getItem("imageOptIn")) {
    store.commit("toggleImageOptIn", true);
  }
  try {
    const preferences = JSON.parse(localStorage.getItem("adminImageOptIn") || "{}");
    if (preferences && typeof preferences === "object" && !Array.isArray(preferences)) {
      store.commit("setAdminImageOptIn", preferences);
    }
  } catch (error) {
    // 损坏的本地偏好不阻断剧本及房间恢复。
  }
  if (localStorage.getItem("zoom")) {
    store.commit("setZoom", parseFloat(localStorage.getItem("zoom")));
  }
  if (localStorage.getItem("isGrimoire")) {
    store.commit("toggleGrimoire", false);
    updatePagetitle(false);
  }
  if (localStorage.roles !== undefined) {
    store.commit("setCustomRoles", JSON.parse(localStorage.roles));
    // 有完整剧本元数据时直接恢复它；中途套空custom会抹掉刚恢复的传奇定义。
    if (localStorage.edition === undefined) {
      store.commit("setEdition", {
        id: "custom",
        fabledRoles: [...store.state.fabled.values()].filter(role => role.isCustom).map(role => role.id)
      });
    }
  }
  if (localStorage.edition !== undefined) {
    // this will initialize state.roles for official editions
    store.commit("setEdition", JSON.parse(localStorage.edition));
  }
  store.commit("setFabledContext", localStorage.getItem("fabledContext") || "");
  // 房间玩家的伪装信息只从服务器授权座位恢复，不能沿用另一房间/座位缓存。
  if (localStorage.bluffs !== undefined && !localStorage.getItem('session') && !window.location.hash.substr(1)) {
    JSON.parse(localStorage.bluffs).forEach((role, index) => {
      store.commit("players/setBluff", {
        index,
        role: store.state.roles.get(role) || {}
      });
    });
  }
  if (localStorage.fabled !== undefined) {
    store.commit("players/setFabled", {
      fabled: JSON.parse(localStorage.fabled).map(
        fabled => resolveFabledRole(fabled, store.state.fabled)
      )
    });
    store.commit("cacheRoomFabledDefinitions", store.state.players.fabled);
  }
  // A room browser must paint only the server's table.  Restoring the old
  // local table first caused a short-lived phantom round table after refresh
  // and let users click seats that the server had already reassigned.
  const restoringRoom =
    (!!localStorage.getItem("session") && !window.location.hash.substr(1)) ||
    !!window.location.hash.substr(1);
  if (localStorage.players && !restoringRoom) {
    store.commit(
      "players/set",
      JSON.parse(localStorage.players).map(player => ({
        ...player,
        role:
          store.state.roles.get(player.role) ||
          store.getters.rolesJSONbyId.get(player.role) ||
          {}
      }))
    );
  }
  /**** Session related data *****/
  if (localStorage.getItem("playerId")) {
    store.commit("session/setPlayerId", localStorage.getItem("playerId"));
  }
  if (localStorage.getItem("session") && !window.location.hash.substr(1)) {
    const [spectator, sessionId, isOwner = false] = JSON.parse(
      localStorage.getItem("session")
    );
    store.commit("session/setSpectator", spectator);
    store.commit("session/setOwner", isOwner);
    store.commit("session/setSessionId", sessionId);
  }

  // listen to mutations
  store.subscribe(({ type, payload }, state) => {
    switch (type) {
      case "toggleGrimoire":
        if (!state.grimoire.isPublic) {
          localStorage.setItem("isGrimoire", 1);
        } else {
          localStorage.removeItem("isGrimoire");
        }
        updatePagetitle(state.grimoire.isPublic);
        break;
      case "setBackground":
        if (payload) {
          localStorage.setItem("background", payload);
        } else {
          localStorage.removeItem("background");
        }
        break;
      case "toggleMuted":
        if (state.grimoire.isMuted) {
          localStorage.setItem("muted", 1);
        } else {
          localStorage.removeItem("muted");
        }
        break;
      case "toggleStatic":
        if (state.grimoire.isStatic) {
          localStorage.setItem("static", 1);
        } else {
          localStorage.removeItem("static");
        }
        break;
      case "toggleImageOptIn":
        localStorage.setItem("adminImageOptIn", JSON.stringify(state.grimoire.adminImageOptIn));
        if (state.grimoire.customImageOptIn) {
          localStorage.setItem("imageOptIn", 1);
        } else {
          localStorage.removeItem("imageOptIn");
        }
        break;
      case "setZoom":
        if (payload !== 0) {
          localStorage.setItem("zoom", payload);
        } else {
          localStorage.removeItem("zoom");
        }
        break;
      case "setEdition":
      case "selectEdition":
        localStorage.setItem("edition", JSON.stringify(state.edition));
        localStorage.setItem("fabledContext", state.fabledContext);
        localStorage.setItem("fabled", JSON.stringify(state.players.fabled));
        if (state.edition.isOfficial) {
          localStorage.removeItem("roles");
        }
        break;
      case "setFabledContext":
        localStorage.setItem("fabledContext", state.fabledContext);
        break;
      case "setCustomRoles":
        if (!payload.length) {
          localStorage.removeItem("roles");
        } else {
          localStorage.setItem("roles", JSON.stringify(payload));
        }
        break;
      case "players/setBluff":
        localStorage.setItem(
          "bluffs",
          JSON.stringify(state.players.bluffs.map(({ id }) => id))
        );
        break;
      case "players/clear":
        localStorage.removeItem("players");
        localStorage.removeItem("bluffs");
        localStorage.removeItem("fabled");
        break;
      case "players/setFabled":
        localStorage.setItem(
          "fabled",
          JSON.stringify(
            state.players.fabled.map(fabled =>
              fabled.isCustom ? fabled : { id: fabled.id }
            )
          )
        );
        break;
      case "players/add":
      case "players/addSeats":
      case "players/update":
      case "players/setIdentity":
      case "players/clearIdentityState":
      case "players/clearStorytellerPrivateView":
      case "players/remove":
      case "players/set":
      case "players/swap":
      case "players/move":
        if (state.players.players.length) {
          localStorage.setItem(
            "players",
            JSON.stringify(
              state.players.players.map(player => ({
                ...player,
                // simplify the stored data
                role: player.role.id || {}
              }))
            )
          );
        } else {
          localStorage.removeItem("players");
        }
        if (type === "players/clearStorytellerPrivateView") {
          localStorage.removeItem("bluffs");
        }
        break;
      case "session/setSessionId":
      case "session/setOwner":
      case "session/setSpectator":
        if (payload) {
          localStorage.setItem(
            "session",
            JSON.stringify([
              state.session.isSpectator,
              state.session.sessionId,
              state.session.isOwner
            ])
          );
        } else if (!state.session.sessionId) {
          localStorage.removeItem("session");
        }
        break;
      case "session/setPlayerId":
        if (payload) {
          localStorage.setItem("playerId", payload);
        } else {
          localStorage.removeItem("playerId");
        }
        break;
      case "session/leaveRoom":
        localStorage.removeItem("session");
        break;
    }
  });
};
